'use client'

import { useRouter } from 'next/navigation'

export default function NotFoundPage() {
  const router = useRouter()

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <p className="text-h-1 font-bold">404</p>
      <h1 className="text-p-1">Page not found</h1>
      <button
        className="mt-8 rounded-sm border border-neutral-blue-500 px-4 py-3"
        onClick={() => router.back()}
      >
        Click here to go back
      </button>
    </div>
  )
}
